// src/components/ContactFormSimple.jsx
import React, { useId, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import arrowCircle from "../img/hero/arrow-circle-2.png";

const SERVICE_ID =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_EMAILJS_SERVICE_ID) ||
  process.env.REACT_APP_EMAILJS_SERVICE_ID;

const TEMPLATE_ID =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_EMAILJS_TEMPLATE_ID) ||
  process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

const PUBLIC_KEY =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_EMAILJS_PUBLIC_KEY) ||
  process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export default function ContactFormSimple() {
  const uid = useId();
  const formRef = useRef(null);
  const [status, setStatus] = useState({ type: "idle", msg: "" });
  const [locked, setLocked] = useState(false);
  const navigate = useNavigate();

  const ids = {
    name: `${uid}-name`,
    email: `${uid}-email`,
    company: `${uid}-company`,
    message: `${uid}-message`,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = formRef.current;

    // honeypot
    const hp = form?.hp_field?.value?.trim();
    if (hp) return;

    // simple validation
    const name = form.user_name.value.trim();
    const email = form.user_email.value.trim();
    const company = form.company.value.trim();
    const message = form.message.value.trim();

    if (!name || !email || !company || !message) {
      setStatus({ type: "error", msg: "Please fill in all fields." });
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setStatus({ type: "error", msg: "Please enter a valid email address." });
      return;
    }

    setStatus({ type: "loading", msg: "Sending..." });

    try {
      await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form, { publicKey: PUBLIC_KEY });
      setLocked(true);
      form.reset();
      // ✅ редирект на сторінку подяки
      navigate("/thank-you", { replace: true });
    } catch (err) {
      const msg = err?.text || err?.message || "Unknown error";
      setStatus({ type: "error", msg: `Oops, something went wrong: ${msg}` });
    } finally {
      // повертаємо кнопку зі стану loading, якщо сталася помилка
      setStatus((prev) => (prev.type === "loading" ? { type: "idle", msg: "" } : prev));
    }
  };

  return (
    <div className="contact-card form-card">
      <h3 className="contact-title">Fill the form and we will contact you</h3>

      <form ref={formRef} className="contact-form" onSubmit={handleSubmit} noValidate>
        {/* honeypot */}
        <input type="text" name="hp_field" tabIndex="-1" autoComplete="off" style={{ display: "none" }} />

        <div className="form-row form-row--2">
          <div className="form-field">
            <label className="form-label" htmlFor={ids.name}></label>
            <input id={ids.name} name="user_name" type="text" placeholder="Full Name" disabled={locked} />
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor={ids.email}></label>
            <input id={ids.email} name="user_email" type="email" placeholder="example@gmail.com" disabled={locked} />
          </div>
        </div>

        <div className="form-field">
          <label className="form-label" htmlFor={ids.company}></label>
          <input id={ids.company} name="company" type="text" placeholder="My company" disabled={locked} />
        </div>

        <div className="form-field">
          <label className="form-label" htmlFor={ids.message}></label>
          <textarea id={ids.message} name="message" placeholder="My message" disabled={locked} />
        </div>

        <button
          className="Primary v2 contact-form__cta"
          type="submit"
          disabled={status.type === "loading" || locked}
          aria-busy={status.type === "loading"}
        >
          <span>{status.type === "loading" ? "Sending..." : "Submit"}</span>
          <img src={arrowCircle} alt="" aria-hidden="true" />
        </button>

        {/* success не показуємо, бо робимо редирект; помилки залишаємо */}
        {status.type === "error" && <p className="form-status form-status--err">{status.msg}</p>}
      </form>
    </div>
  );
}
